export default "__VITE_ASSET__2d804031__"